import React, { useState } from 'react';
import './Onboarding.css'; // This is a new CSS file we will create
import { 
    FaChartLine, 
    FaLayerGroup,
    FaLightbulb, 
    FaTachometerAlt, 
    FaStethoscope,
    FaCheckCircle,
} from 'react-icons/fa';

const Onboarding = () => {
    // State to track which time option is selected
    const [selectedTime, setSelectedTime] = useState('1-3 hours/week');

    // Options to be displayed as buttons
    const timeOptions = [
        '1-3 hours/week',
        '4-7 hours/week',
        '8-15 hours/week',
        '15+ hours/week'
    ];

    return (
        <div className="preferences-container">
            {/* The info section remains consistent */}
          <div className="info-section">
                <div className="info-content">
                    <h1 className="title">
                        <span role="img" aria-label="target" className="target-icon">🎯</span>
                        Prepare Smarter for CPHQ – With AI On Your Side
                    </h1>
                    <p className="subtitle">Your Personalized CPHQ Prep Platform</p>
                    
                    <ul className="features-list">
                        <li>
                          <span className="feature-icon-frame"><img src="/assets/why/study.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>AI Study Planner</h2>
                                <p>Personalized study goals and reminders</p>
                            </div>
                        </li>
                        <li>
                            <span className="feature-icon-frame"><img src="/assets/why/study.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Interactive Content</h2>
                                <p>Flashcards, videos, summaries</p>
                            </div>
                        </li>
                        <li>
                          <span className="feature-icon-frame"><img src="/assets/why/Mock.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Mock Exams</h2>
                                <p>Adaptive quizzes and smart scoring</p>
                            </div>
                        </li>
                        <li>
                         <span className="feature-icon-frame"><img src="/assets/why/performancedashboard.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Performance Dashboard</h2>
                                <p>Visual progress tracking</p>
                            </div>
                        </li>
                        <li>
                            <span className="feature-icon-frame"><img src="/assets/why/aitutor.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>AI Tutor</h2>
                                <p>Ask anything, anytime — Built on GPT-4o</p>
                            </div>
                        </li>
                        <li>
                         <span className="feature-icon-frame"><img src="/assets/why/readness.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Readiness Meter</h2>
                                <p>Know when you're ready to pass</p>
                            </div>
                        </li>
                    </ul>
                    <div className='footer-text'>
                       <p>Built with healthcare professionals in mind. HIPAA-aware. Secure. Mobile-first. Accessible.</p>
                    </div>
                </div>
            </div>

            {/* The form section for learning preferences */}
            <div className="form-section">
                <div className="form-content">
                    <h2>Learning Preferences</h2>
                    <p className="form-subtitle">
                        Help us create the perfect learning experience for you
                    </p>

                    <form>
                        <label className="question-label">How much time can you commit weekly?</label>
                        <div className="options-grid">
                            {timeOptions.map(option => (
                                <button
                                    key={option}
                                    type="button"
                                    className={`option-button ${selectedTime === option ? 'active' : ''}`}
                                    onClick={() => setSelectedTime(option)}
                                >
                                    {option}
                                </button>
                            ))}
                        </div>
                        
                        <button type="submit" className="continue-button">Continue to Dashboard</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Onboarding;